export default __webpack_public_path__ + "static/media/iitbLogo.889e37eb.png";